var _style, _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommonFileText1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000134933315956084604750000001335976133418267564_);}\r\n\t.st1{fill:#121212;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 24,
    height: 24
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000094614980666307280970000015277526044494981787_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000094614980666307280970000015277526044494981787_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21,24.2H3c-0.7,0-1.3-0.3-1.8-0.7c-0.5-0.5-0.7-1.1-0.7-1.8V2.2c0-0.7,0.3-1.3,0.7-1.8S2.3-0.2,3-0.2h15 c0.7,0,1.3,0.3,1.7,0.7l3,2.9c0.2,0.2,0.4,0.5,0.6,0.8c0.1,0.3,0.2,0.6,0.2,1v16.6c0,0.7-0.3,1.3-0.7,1.8S21.7,24.2,21,24.2z  M3,1.8c-0.1,0-0.3,0.1-0.4,0.1C2.6,2,2.5,2.1,2.5,2.2v19.5c0,0.1,0.1,0.3,0.1,0.4c0.1,0.1,0.2,0.1,0.4,0.1h18 c0.1,0,0.3-0.1,0.4-0.1s0.1-0.2,0.1-0.4V5.1c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.1-0.1-0.2l-3-2.9c-0.1-0.1-0.2-0.1-0.3-0.1H3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18,9.2H6c-0.6,0-1-0.4-1-1s0.4-1,1-1h12c0.6,0,1,0.4,1,1S18.6,9.2,18,9.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18,13.8H6c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1C19,13.3,18.6,13.8,18,13.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12,18.2H6c-0.6,0-1-0.4-1-1s0.4-1,1-1h6c0.6,0,1,0.4,1,1S12.6,18.2,12,18.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonFileText1);
export default __webpack_public_path__ + "static/media/common-file-text 1.c7adfd03645bfed714bc67c466c328e7.svg";
export { ForwardRef as ReactComponent };